/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_OPEN_REG_REPORT = gql`
query GetOpenBoxReport($presentationId: MID!, $invitedByUser: MID, $invitedByUserEmail: String, $filter: UserAndBoxesFilterInput, $options: GetManyOptions) {
    getOpenBoxReport(presentationId: $presentationId, invitedByUser: $invitedByUser, invitedByUserEmail: $invitedByUserEmail, filter: $filter, options: $options) {
      csvUrl
    }
  }`;